// src/components/Sidebar.jsx
import React from 'react';
import SportsCricketOutlinedIcon from '@mui/icons-material/SportsCricketOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CasinoOutlinedIcon from '@mui/icons-material/CasinoOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateActive } from '../redux/activeSlice';

import { Link } from 'react-router-dom'
import { Search, Home, Gamepad2, Dice5, Trophy, Table2, SearchIcon, LoaderPinwheel, SpadeIcon, EthernetPort, Gem, Gamepad } from 'lucide-react'
import { Games } from '@mui/icons-material';

const NAV_ITEMS = [
    {
        name: 'Lobby',
        path: '/',
        icon: <HomeOutlinedIcon />,
        active: true
    },
    {
        name: 'Sports',
        path: '/sports',
        icon: <SportsCricketOutlinedIcon />,
        active: true
    },
    {
        name: 'Casino',
        path: '/casino',
        icon: <CasinoOutlinedIcon />,
        active: true
    },
    {
        name: 'Mini Games',
        path: '/mini-games',
        icon: <Gamepad />,
        active: true
    },
    {
        name: 'Lottery',
        path: '/lottery',
        icon: <Gem />,
        active: true
    },
    {
        name: 'Table Games',
        path: 'table-games',
        icon: <SpadeIcon />,
        active: true
    },
    {
        name: 'slots',
        path: '/slots',
        icon: <EthernetPort />,
        active: true
    },
]

const Subnavbar = () => {
    const activeRoute = useSelector(state => state.active.activeRoute);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const onClickItem = (path) => {
        dispatch(updateActive({ activeRoute: path }));
        navigate(path)
    }

    return <>
        <nav className="bg-[#0B1622] mt-[-20px]">
            <div className=" md:px-4">
                <div className="flex items-center justify-between h-16 w-full overflow-auto">
                    <div className="flex items-center">
                        <div>
                            <div className="flex items-center space-x-4 me-4 md:me-0">
                                {NAV_ITEMS.map(item => (<button key={item.name} disabled={!item.active}
                                    onClick={() => onClickItem(item.path)}
                                    className={`flex rounded-lg px-6 items-center font-bold leading-none text-white py-3 text-lg ${activeRoute === item.path ? 'bg-active-btn' : 'bg-inactive-btn'}`}
                                >
                                    <span className='me-2'>{item.icon}</span>
                                    {item.name}
                                </button>))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        {/* <aside className="w-100 text-white p-3">
            <div className="flex">
                {NAV_ITEMS.map(item => (<div key={item.name} className={`px-3 py-1 flex items-center justify-center cursor-pointer ${activeRoute === item.path ? 'text-white' : 'text-gray-500'}`}
                    onClick={() => onClickItem(item.path)}>
                    <div className='pe-1'>{item.icon}</div>
                    <div>{item.name}</div>
                </div>))}
            </div>
        </aside> */}
    </>
};
export default Subnavbar;


